export default __webpack_public_path__ + "b4aa7b27bed392d6dc6bc47660f20a49.jpg";